import { logInfo, logWarn } from '@/lib/logger';

const SERVICE_WORKER_PATH = '/play-claw-sw.js';

export const registerPwaServiceWorker = async (): Promise<ServiceWorkerRegistration | null> => {
  if (!('serviceWorker' in navigator)) {
    return null;
  }

  try {
    const serviceWorkerRegistration = await navigator.serviceWorker.register(
      SERVICE_WORKER_PATH
    );
    logInfo('pwa.service_worker.registered', 'PWA service worker registered', {
      scope: serviceWorkerRegistration.scope,
    });
    return serviceWorkerRegistration;
  } catch (error) {
    logWarn('pwa.service_worker.failed', 'PWA service worker registration failed', {
      error: String(error),
    });
    return null;
  }
};
